import { useTranslation } from "react-i18next"
import { InvoicePaymentStateLabelsMap } from "../constants/invoices"
import { ChargeState } from "@oysterhr/schema"
import { getClientInvoiceChargeState } from "../utils"
import { Badge } from "@oysterhr/ui"

interface Props {
  chargeState: ChargeState
  dueDate?: Date
}

export const InvoicePaymentStatePill = ({ chargeState, dueDate }: Props) => {
  const { t } = useTranslation("Invoices")
  const { variation, translationKey } =
    InvoicePaymentStateLabelsMap[getClientInvoiceChargeState({ chargeState, dueDate })]

  return <Badge variation={variation}>{t(translationKey)}</Badge>
}
